import React from 'react';
import { Col, Button } from 'antd';
import ProductSegment from '../types/ProductSegment';
import { FormSegment, FormSegmentData } from './FormSegment';
import { cloneProductSegment } from '../api/productAlerts.api';
import styles from './FormSegment.module.less';

type FormCloneSegmentProps = {
  productSegment: ProductSegment;
  closeModal: () => void;
  onComplete: () => void;
};

const renderFormFooter = (disabledSubmit: boolean) => {
  return (
    <Col span={24}>
      <Button
        type="primary"
        htmlType="submit"
        disabled={disabledSubmit}
        className={`${styles.button} ${styles.buttonCenter}`}
      >
        Submit
      </Button>
    </Col>
  );
};

export const FormCloneSegment: React.FC<FormCloneSegmentProps> = ({ productSegment, closeModal, onComplete }) => {
  const { productSegmentId, productSegmentName } = productSegment;

  const handleSubmitForm = async (data: FormSegmentData) => {
    await cloneProductSegment({ ...data, productSegmentId });
    onComplete();
  };

  const clonedProductSegment = {
    ...productSegment,
    productSegmentName: `Copy of ${productSegmentName}`,
  };

  return (
    <FormSegment
      productSegment={clonedProductSegment}
      closeModal={closeModal}
      onSubmitForm={handleSubmitForm}
      formTitle="Clone Product Segment"
      successMessage="Product Segment has been cloned!"
      renderFormFooter={renderFormFooter}
    />
  );
};
